import React, { useState, useEffect, useRef } from 'react'
import CssBaseline from '@mui/material/CssBaseline';
import Button from '@mui/material/Button';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import PupUPbomList from './../popupbom/PupUPbomList';
import { styled } from '@mui/material/styles';
import './newdocument.scss';
import Field from './NdField';
import Detaildocument from './Detaildocument';
import PopUpdetailSpecId from './popupcomponent/popUpdetailSpecId';
import PopUpcustomers from './popupcomponent/popUpcustomers';
import PopUpItemdetail from './popupcomponent/popUpItemdetail';
import FetchApi from '../../../customhooks/Functionapi';
import { objectHearder, ItmeTypeID } from './objectdata/typeobject';
import { useSelector, useDispatch } from 'react-redux'
import { Container } from '@mui/material';
import { UploadFiles } from '../../../customhooks/FuctionUpload';
import PopUpPackagingDetail from './popupcomponent/popUpPackagingDetail';
import { runnumberDocument } from './../../../customhooks/FunctionRunnumber';
import Swal from 'sweetalert2';
import moment from 'moment/moment.js';
import { Route, Link, Routes, useLocation, useNavigate, useParams } from 'react-router-dom';

const options = [
    { value: 'chocolate', label: 'Chocolate' },
    { value: 'strawberry', label: 'Strawberry' },
    { value: 'vanilla', label: 'Vanilla' },
];

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const Newdocuments = (props) => {
    const navigate = useNavigate();
    let { id } = useParams();
    const FetchApis = new FetchApi()
    const userId = sessionStorage.getItem("userId")

    const dataHead = useSelector((state) => state.documentHeader.valueHeader);

    const [addImages, setAddImages] = useState([]);
    const [dataHeader, setDataHeader] = useState(objectHearder);

    const [datatypeproduct, setDataTypeproduct] = useState([]);
    const [typeproductdetail, setTypeproductdetial] = useState([]);
    const [ischeck, setIscheck] = useState(false);


    const [saleapproved, setSaleapproved] = useState([]);
    const [flowrunList, setFlowrunList] = useState([]);

    useEffect(() => {
        // getJournalById(props.insertId)
        gettypePorduct()
        getsaleapproved();
        runjournalcode();

    }, [])

    const runjournalcode = () => {
        runnumberDocument(objectHearder.typeDocement).then(result => {

            if (result) {
                setDataHeader({ ...dataHeader, JournalCode: result })
            }

        })
    }


    // ส่วนเลือก ประเภท  new  and revise 
    const gettypePorduct = () => {

        FetchApis.FethcGet(`/typeproduct/typeProductgroup`).then(res => {
            if (res) {
                setDataTypeproduct(res.data)

            }
        })
    }

    const gettypedetailproduct = (code) => {

        setDataHeader({
            ...dataHeader, Typeproduct: code,
            PurposeDetail: []
        })

        setIscheck(false)

        setTimeout(() => {
            setIscheck(true)
        }, 500);

        FetchApis.FethcGet(`/typeproduct/typeProductByCode/${code}`).then(res => {

            if (res) {
                setTypeproductdetial(res.data);
            }
        })
    }

    const handleChange = (e) => {

        const { PurposeDetail } = dataHeader
        const ischecked = e.target.checked;
        const istext = e.target.value;

        if (ischecked == true) {
            if (e.target.name == 'typeDetail') {
                setDataHeader({ ...dataHeader, PurposeDetail: [...PurposeDetail, istext] })
            }
        }
        else if (ischecked == false) {
            setDataHeader({
                ...dataHeader,
                PurposeDetail: PurposeDetail.filter((e) => e !== istext),
            });
        }
    }

    const getsaleapproved = () => {

        FetchApis.FethcGet(`/flowsystem/flowgroupbyName`).then(res => {
            if (res) {

                setSaleapproved(res.data);
            }
        })
    }

    //  ส่วนกรเลือก sale เพิ่มแสดง flow running
    const isChangflow = (val) => {
        setDataHeader({ ...dataHeader, FlowrunId: val });
    }

    const handleChangeSale = (e) => {
        var val = e.target.value;
        setDataHeader({
            ...dataHeader, 
            SaleAckUserID: val,
            UserIDRequest:"คุณ "+val

        })

        FetchApis.FethcGet(`/flowsystem/flowbyNamelist/${val}`).then(res => {
            if (res) {
                if (res) {
                    setFlowrunList(res.data);
                }

            }
        })

    };

    const handleFile = event => {
        var input = document.getElementById('loadfile');
        // console.log(input)
        if (input.files[0]) {
            const file = input.files[0]
            const size = file.size // it's in bytes
            const ext = file.name.split(".").pop();

            const newName = `${Date.now()}.` + ext;
            const renamedFile = new File([file], newName, {
                type: file.type,
            });

            if (size <= 5000000) {
                UploadFiles(renamedFile).then(res => {
                    //upload file ก่อน ค่อย insert 
                    if (res) {
                        setDataHeader({ ...dataHeader, PartFileECN: newName })
                    }
                })
            } else {
                
                Swal.fire({
                    title: "แจ้งเตือน",
                    text: "ขนาดไฟล์เกินกำหนด 5M ",
                    icon: "warning"
                });

            }

        }

    };

    function isRemoveImages(index) {
        const newArray = [...addImages];
        newArray.splice(index, 1);
        setAddImages(newArray);

    }

    props.getdataheader(dataHeader)

    function onCheckType(e) {
        const { ItemTypeID } = dataHeader;
        const value = e.target.value;
        setDataHeader({ ...dataHeader, ItemTypeID: value })
    }

    function inDataCustomer(customerName, codecustomer) {
        setDataHeader({ ...dataHeader, CustID: codecustomer, CustName: customerName })
    }

    function inDataCustomerDetail(BRANDCODE, ITEMID, ITEMNAME,SPECID,SPECNAME) {
        var databranid = BRANDCODE.replace("'", " ")

        setDataHeader({
            ...dataHeader,
            ItemID: ITEMID,
            BrandID: databranid,
            ItemName: ITEMNAME,
            SpecId:SPECID,
            SpecName:SPECNAME
        })
    }

    const handleChangeText = e => {
        // var format = /^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/;
        // Allow only letters, numbers, and spaces
        // var format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
        // var dataclecking=format.test(e.target.value);
        var input = e.target.value;
        // const cleanInput = input.replace(/[^a-zA-Z0-9ก-๙\s()#/.%:";,=\-@$<>+*/?!]/g, "");
        const cleanInput = input.replace(/[^a-zA-Z0-9ก-๙\s()#/.%:";,=\-&@$<>+*/?!]/g, "");
        setDataHeader({ ...dataHeader, [e.target.name]: cleanInput });
    };

    const isGetPacklist = (datalist) => {
        setDataHeader({ ...dataHeader, PackagingDetails: datalist })
    }


    const inDetailSpec = (SPECID, SPECNAME) => {
        setDataHeader({
            ...dataHeader,
            SpecId: SPECID,
            SpecName: SPECNAME
        })
    }

    return (
        <div className='nd-page'>
            <CssBaseline />
            <Container maxWidth={false}>
              {/* grid 2x2 ให้ฟอร์มพอดีจอ กล่องในแถวเดียวกันสูงเท่ากัน
                  แถวบน = เอกสาร | ลูกค้า , แถวล่าง = คำร้อง | Spec (จัดตำแหน่งด้วย class nd-pos-*) */}
              <div className='nd-columns'>

                {/* ข้อมูลเอกสาร */}
                <section className='nd-card nd-pos-1'>
                    <div className='nd-card-head'>
                        <span className='nd-card-title'>ข้อมูลเอกสาร</span>
                    </div>
                    <div className='nd-grid nd-grid-4'>
                        <Field label='เอกสารบรรจุ (SSD)'>
                            <input type='text' disabled className='nd-input nd-input-code' value={dataHeader.JournalCode}
                                onChange={(e) => setDataHeader({ ...dataHeader, JournalCode: e.target.value })} />
                        </Field>
                        <Field label='วันที่สร้างเอกสาร'>
                            <div className='nd-static'>{moment(dataHeader.TransDate).format('DD/MM/yyyy')}</div>
                        </Field>
                        <Field label='วันที่ Approved'>
                            <div className='nd-static'>{moment(dataHeader.LastApprovedDate).format('DD/MM/yyyy')}</div>
                        </Field>
                        <Field label='เลขที่เอกสาร (ECN)' required>
                            <input type='text' className='nd-input'
                                value={dataHeader.RefECN} onChange={(e) => setDataHeader({ ...dataHeader, RefECN: e.target.value })} />
                        </Field>
                        <Field label='ไฟล์แนบ ECN' span={4}>
                            <div className='nd-upload'>
                                <Button variant="outlined" size="small"
                                    component="label"
                                    role={undefined}
                                    tabIndex={-1}
                                    startIcon={<CreateNewFolderIcon />}>
                                    Upload files
                                    <VisuallyHiddenInput
                                        type="file" accept="image/*,.pdf" onChange={handleFile} id='loadfile'
                                        multiple
                                    />
                                </Button>
                                <span className={dataHeader.PartFileECN ? 'nd-file' : 'nd-file nd-muted'}>
                                    {dataHeader.PartFileECN || 'ยังไม่ได้เลือกไฟล์ (รูปภาพ หรือ pdf ไม่เกิน 5MB)'}
                                </span>
                            </div>
                        </Field>
                    </div>
                </section>

                {/* ส่วนของคำร้องขอ */}
                <section className='nd-card nd-pos-3'>
                    <div className='nd-card-head'>
                        <span className='nd-card-title'>ส่วนของคำร้องขอ</span>
                    </div>
                    <div className='nd-grid nd-grid-2'>
                        <Field label='ประเภทสินค้า' span={2}>
                            <div className='nd-choices'>
                                {ItmeTypeID.map((val, index) => (
                                    <label className='nd-chip' key={index}>
                                        <input type='radio' name='1' value={val} onClick={(e) => onCheckType(e)}
                                            defaultChecked={dataHead.ItemTypeID == val} />
                                        <span>{val}</span>
                                    </label>
                                ))}
                            </div>
                        </Field>

                        <Field label='ประเภทงาน'>
                            <div className='nd-choices'>
                                {datatypeproduct.map((item, index) => (
                                    <label className='nd-chip' key={index}>
                                        <input type='radio' name='typeproduct' value={item.typecode}
                                            onClick={(e) => gettypedetailproduct(e.target.value)} />
                                        <span>{item.typeproduct}</span>
                                    </label>
                                ))}
                            </div>
                        </Field>

                        <Field label='รายละเอียดงาน'>
                            {typeproductdetail.length > 0 && ischeck != false ?
                                <div className='nd-checklist'>
                                    {typeproductdetail.map((item, index) => (
                                        <label className='nd-check' key={index}>
                                            <input type='checkbox' value={item.detailproduct} name={'typeDetail'}
                                                onChange={(e) => handleChange(e)}
                                                defaultChecked={false}
                                            />
                                            <span>{item.detailproduct}</span>
                                        </label>
                                    ))}
                                </div> :
                                <div className='nd-static nd-muted'>เลือกประเภทงานก่อน</div>
                            }
                        </Field>

                        <Field label='วัตถุประสงค์' span={2}>
                            <textarea className='nd-input nd-textarea'
                                name='Purpose'
                                value={dataHeader.Purpose}
                                onChange={(e) => handleChangeText(e)}
                                placeholder='อธิบายคำร้อง (500 Digit)'
                                maxLength={500}
                            />
                        </Field>

                        <Field label='ชื่อผู้ร้องขอ' required>
                            <select className='nd-input' name="saleapproved" id="saleapproved"
                                onChange={(e) => handleChangeSale(e)}>
                                <option value={''} >เลือกผู้อนุมัติ</option>
                                {saleapproved.map((item, index) => (
                                    <option key={index} value={item.flowName}>คุณ {item.flowName}</option>
                                ))}
                            </select>
                        </Field>

                        <Field label='ลำดับอนุมัติ' required>
                            <select className='nd-input' name="flowapproved" id="flowapproved"
                                onChange={(e) => isChangflow(e.target.value)}>
                                <option value={''}>เลือก flow อนุมัติ</option>
                                {flowrunList.map((item, index) => (
                                    <option key={index} value={item.flowId}>{item.detail}</option>
                                ))}
                            </select>
                        </Field>

                        <Field label='ผู้ร้องขอ' span={2}>
                            <input type='text'
                                name='UserIDRequest'
                                value={dataHeader.UserIDRequest}
                                onChange={(e) => handleChangeText(e)}
                                placeholder='ชื่อ / สกุล' className='nd-input' />
                        </Field>
                    </div>
                </section>

                {/* ข้อมูลลูกค้า / สินค้า */}
                <section className='nd-card nd-pos-2'>
                    <div className='nd-card-head'>
                        <span className='nd-card-title'>ข้อมูลลูกค้า / สินค้า</span>
                    </div>
                    <div className='nd-grid nd-grid-cust'>
                        <Field label='รหัสลูกค้า'>
                            <div className='nd-input-group'>
                                <input type='text' className='nd-input'
                                    name='CustID'
                                    value={dataHeader.CustID}
                                    onChange={(e) => handleChangeText(e)}
                                />
                                <span className='nd-picker' title='ค้นหาลูกค้า'>
                                    <PopUpcustomers inDataCustomer={inDataCustomer} />
                                </span>
                            </div>
                        </Field>
                        <Field label='ชื่อลูกค้า'>
                            <input type='text'
                                name='CustName'
                                value={dataHeader.CustName}
                                onChange={(e) => handleChangeText(e)}
                                className='nd-input' />
                        </Field>

                        <Field label='รหัสสินค้า'>
                            <div className='nd-input-group'>
                                <input type='text' className='nd-input'
                                    name='ItemID'
                                    value={dataHeader.ItemID}
                                    onChange={(e) => handleChangeText(e)}
                                />
                                <span className='nd-picker' title='ค้นหาสินค้า'>
                                    <PopUpItemdetail inDataCustomerDetail={inDataCustomerDetail} />
                                </span>
                            </div>
                        </Field>
                        <Field label='ชื่อสินค้า'>
                            <input type='text'
                                name='ItemName'
                                value={dataHeader.ItemName}
                                onChange={(e) => handleChangeText(e)}
                                className='nd-input' />
                        </Field>

                        <Field label='ตราสินค้า'>
                            <input type='text'
                                name='BrandID'
                                value={dataHeader.BrandID}
                                onChange={(e) => handleChangeText(e)}
                                className='nd-input'
                            />
                        </Field>
                    </div>
                </section>

                {/* การบรรจุ / Spec */}
                <section className='nd-card nd-pos-4'>
                    <div className='nd-card-head'>
                        <span className='nd-card-title'>การบรรจุ / Spec</span>
                        <span className='nd-card-action'>
                            {dataHeader.ItemID ? <PupUPbomList ItemId={dataHeader.ItemID} /> : <span className='nd-hint'>เลือกรหัสสินค้าก่อน เพื่อดูข้อมูล BOM</span>}
                        </span>
                    </div>
                    <div className='nd-grid nd-grid-2'>
                        <Field label='การบรรจุงาน'>
                            <div className='nd-input-group'>
                                <input type='text'
                                    name='PackagingDetails'
                                    value={dataHeader.PackagingDetails}
                                    onChange={(e) => handleChangeText(e)}
                                    className='nd-input'
                                />
                                <span className='nd-picker' title='เลือกการบรรจุ'>
                                    <PopUpPackagingDetail isGetPacklist={isGetPacklist} />
                                </span>
                            </div>
                        </Field>
                        <Field label='Spec ID'>
                            <div className='nd-input-group'>
                                <input type='text'
                                    name='SpecId'
                                    value={dataHeader.SpecId}
                                    onChange={(e) => handleChangeText(e)}
                                    className='nd-input'
                                />
                                <span className='nd-picker' title='ค้นหา Spec'>
                                    <PopUpdetailSpecId inDetailSpec={inDetailSpec} />
                                </span>
                            </div>
                        </Field>
                        <Field label='Spec Detail' span={2}>
                            <input type='text'
                                name='SpecName'
                                value={dataHeader.SpecName}
                                onChange={(e) => handleChangeText(e)}
                                className='nd-input' />
                        </Field>
                        <Field label='อธิบายเพิ่มเติม 1' span={2}>
                            {/* SDSS_Head.Remark เป็น varchar(150) */}
                            <textarea className='nd-input nd-textarea nd-textarea-remark'
                                name='Remark'
                                value={dataHeader.Remark}
                                onChange={(e) => handleChangeText(e)}
                                placeholder='อธิบายเพิ่มเติม (150 Digit)'
                                maxLength={150}
                            />
                        </Field>
                    </div>
                    <div className='nd-meta'>
                        <span><b>Confirm By :</b> {dataHeader.nameConfirme} {dataHeader.lastname}</span>
                        <span><b>วันที่/เวลา :</b> {moment(dataHeader.stamptimeUpdate).format('DD/MM/yyyy hh:mm:ss')}</span>
                    </div>
                </section>
              </div>
            </Container>
            <div>
                {dataHeader.JournalCode != "" &&
                    <Detaildocument
                        getdatadetail={props.getdatadetail}
                        isRemoveImages={isRemoveImages}
                        getdataImages={props.getdataImages}
                        dataHeader={dataHeader}
                        sectionHeader={true}
                    />
                }

            </div>
        </div>
    )
}

export default Newdocuments
